import { render, staticRenderFns } from "./RcPerformance.vue?vue&type=template&id=3fde52e0&"
import script from "./RcPerformance.vue?vue&type=script&lang=js&"
export * from "./RcPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports